export const formatNumber = (value, digits = 2) => Number(value || 0).toLocaleString('zh-CN', {
  minimumFractionDigits: digits,
  maximumFractionDigits: digits
});

export const formatSigned = (value) => {
  const number = Number(value || 0);
  return `${number >= 0 ? '+' : ''}${formatNumber(number, 2)}`;
};

export const formatSignedPercent = (value, digits = 2) => {
  const number = Number(value || 0);
  return `${number >= 0 ? '+' : ''}${formatNumber(number, digits)}%`;
};

export const formatPercent = (value, digits = 2) => `${formatNumber(Number(value || 0), digits)}%`;

export const formatCurrencyBreakdown = (items, signed = false) => {
  if (!Array.isArray(items) || !items.length) {
    return [];
  }
  return items
    .map((item) => {
      const currency = String(item?.currency || 'USD').toUpperCase();
      const amount = Number(item?.amount || 0);
      return {
        currency,
        amount,
        label: `${currency} ${signed ? formatSigned(amount) : formatNumber(amount, 2)}`
      };
    })
    .filter((item) => Math.abs(item.amount) > 0.0001);
};

export const formatCompactDate = (value, t) => value || (t ? t('misc.noLimit') : '不限');

export const getPulseValueDigits = (item) => {
  const label = String(item?.label || '').toUpperCase();
  if (label.includes('/')) {
    return label.includes('JPY') ? 2 : 4;
  }
  return Number(item?.value) >= 100 ? 2 : 4;
};
